import { FC, Suspense } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
  useHref,
} from 'react-router-dom';
import { HeroUIProvider } from '@heroui/system';
import { ToastProvider } from '@heroui/react';
import { Splash } from '@ui/common/splash.tsx';

import Layout from '@app/layout';
import MainPage from '@pages/main';
import CategoriesPage from '@pages/categories';
import ProductPage from '@pages/product';
import CategoryPage from '@pages/category';
import SubcategoryPage from '@pages/subcategory';
import SearchPage from '@pages/search';
import CartPage from '@pages/cart';
import CheckoutPage from '@pages/checkout';
import ProfilePage from '@pages/profile';
import FavoritePage from '@pages/favorite';
import AuthorizationPage from '@pages/authorization';
import LocationPage from '@pages/location';
import PharmacyPage from '@pages/pharmacy';
import AvailabilityPage from '@pages/availability';
import StorePage from '@pages/store';
import StatusPage from '@pages/status';
import PrivacyOfPolicy from '@pages/privacy-of-policy';
import Terms from '@pages/terms';
import AboutPage from '@pages/about';
import EditProfilePage from '@pages/edit-profile';
import ContactsPage from '@pages/contacts';
import NotificationsPage from '@pages/notifications';
import OrdersPage from '@pages/orders';
import OrderPage from '@pages/order';
import CheckoutSuccessPage from '@pages/checkout-success';
import CheckoutFailurePage from '@pages/checkout-failure';
import PopularPage from '@pages/popular';

const Internal: FC = () => {
  const navigate = useNavigate();

  return (
    <HeroUIProvider disableRipple navigate={navigate} useHref={useHref}>
      <ToastProvider placement="top-center" />

      <Suspense fallback={<Splash />}>
        <Routes>
          <Route path="/" Component={Layout}>
            <Route path="/initial" Component={LocationPage} />

            <Route path="/" Component={MainPage} />

            <Route path="/category" Component={CategoriesPage} />

            <Route path="/category/:categoryId" Component={CategoryPage} />

            <Route
              path="/category/:categoryId/:subcategoryId"
              Component={SubcategoryPage}
            />

            <Route path="/products/:productId" Component={ProductPage} />

            <Route path="/search" Component={SearchPage} />

            <Route path="/cart" Component={CartPage} />

            <Route path="/cart/checkout" Component={CheckoutPage} />

            <Route
              path="/cart/checkout/:orderId/success"
              Component={CheckoutSuccessPage}
            />

            <Route
              path="/cart/checkout/:orderId/failure"
              Component={CheckoutFailurePage}
            />

            <Route path="/favorite" Component={FavoritePage} />

            <Route path="/profile" Component={ProfilePage} />

            <Route path="/profile/edit" Component={EditProfilePage} />

            <Route path="/location" Component={LocationPage} />

            <Route path="/popular" Component={PopularPage} />

            <Route path="/pharmacy" Component={PharmacyPage} />

            <Route path="/store" Component={StorePage} />

            <Route
              path="/pharmacy/:pharmacyId/availability"
              Component={AvailabilityPage}
            />

            <Route path="/status" Component={StatusPage} />

            <Route path="/about" Component={AboutPage} />

            <Route path="/contacts" Component={ContactsPage} />

            <Route path="/notifications" Component={NotificationsPage} />

            <Route path="/orders" Component={OrdersPage} />

            <Route path="/orders/:orderId" Component={OrderPage} />

            <Route path="*" element={<Navigate to="/" />} />
          </Route>

          <Route path="/authorization" Component={AuthorizationPage} />

          <Route path="/privacy-of-policy" Component={PrivacyOfPolicy} />

          <Route path="/terms" Component={Terms} />

          <Route path="*" element={<div></div>} />
        </Routes>
      </Suspense>
    </HeroUIProvider>
  );
};

export const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Internal />
    </BrowserRouter>
  );
};
